<template>
  <a-layout style="min-height: 100vh">
    <a-layout-sider v-model="collapsed" class="admin-sider" collapsible>
      <div class="logo">
        <img :src="logo" alt="锐高商城">
        <strong v-if="!collapsed">锐高</strong>
      </div>
      <div class="admin-menu-scroll">
        <a-menu theme="dark" :default-selected-keys="[$route.path]" mode="inline">
          <template v-for="item in routes">
            <template v-if="!item.hidden">

              <a-menu-item 
                v-if="isSingleItem(item)" 
                :key="resolveKey(item)"
                @click="handleSingleClick(item)"
              >
                <a-icon :type="getIcon(item)" />
                <span>{{ getTitle(item) }}</span>
              </a-menu-item>

              <a-sub-menu 
                v-else 
                :key="item.path"
              >
                <span slot="title">
                  <a-icon :type="item.meta && item.meta.icon ? item.meta.icon : 'appstore'" />
                  <span>{{ item.meta && item.meta.title ? item.meta.title : '未命名' }}</span>
                </span>
                <template v-for="child in item.children">
                  <a-menu-item v-if="!child.hidden" :key="resolvePath(item.path, child.path)"
                    @click="handleMenuClick(item.path, child.path)">
                    <span>{{ child.meta && child.meta.title ? child.meta.title : child.name }}</span>
                  </a-menu-item>
                </template>
              </a-sub-menu>

            </template>
          </template>
        </a-menu>
      </div>
    </a-layout-sider>

    <a-layout class="admin-main-layout">
      <a-layout-header class="admin-header" style="background: #fff; padding: 0 20px; display:flex; justify-content:space-between; align-items:center;">
        <a-icon 
          class="trigger" 
          :type="collapsed ? 'menu-unfold' : 'menu-fold'" 
          @click="() => (collapsed = !collapsed)" 
          style="font-size: 18px; cursor: pointer;"
        />
        <div class="admin-header-right">
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              管理员 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item @click="handleLogout">退出登录</a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-layout-header>

      <a-layout-content class="layout-content">
        <router-view />
      </a-layout-content>
    </a-layout>
    
  </a-layout>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
        collapsed: false,
        logo: require('@/assets/logo.png')
      }
    },
    computed: {
      ...mapState({
        routes: state => state.routes
      })
    },
    methods: {
      isSingleItem(item) {
        // 1. 如果没有 children -> 单菜单
        if (!item.children || item.children.length === 0) {
          return true;
        }
        // 2. 如果是根路径 "/" 且只有一个子节点 -> 也是单菜单 (Dashboard情况)
        if (item.path === '/' && item.children.length === 1) {
          return true;
        }
        return false;
      },

      getTitle(item) {
        if (item.path === '/' && item.children && item.children.length === 1) {
          return item.children[0].meta?.title || item.children[0].title;
        }
        return item.meta?.title || item.title;
      },

      getIcon(item) {
        if (item.path === '/' && item.children && item.children.length === 1) {
          return item.children[0].meta?.icon || item.children[0].icon || 'desktop';
        }
        return item.meta?.icon || item.icon || 'desktop';
      },

      resolveKey(item) {
        if (item.path === '/' && item.children && item.children.length === 1) {
          return this.resolvePath(item.path, item.children[0].path);
        }
        return item.path;
      },

      handleSingleClick(item) {
        let targetPath = item.path;
        if (item.path === '/' && item.children && item.children.length === 1) {
          targetPath = this.resolvePath(item.path, item.children[0].path);
        }
        if (this.$route.path !== targetPath) {
          this.$router.push(targetPath);
        }
      },

      resolvePath(basePath, routePath) {
        if (!routePath) return basePath;
        if (basePath.endsWith('/')) return basePath + routePath;
        return basePath + '/' + routePath;
      },

      handleMenuClick(basePath, routePath) {
        const fullPath = this.resolvePath(basePath, routePath);
        if (this.$route.path !== fullPath) {
          this.$router.push(fullPath);
        }
      },

      handleLogout() {
        this.$store.dispatch('Logout');
      }
    }
  }
</script>

<style scoped>
.logo {
  height: 58px;
  margin: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  overflow: hidden;
  flex-shrink: 0;
}
.admin-sider {
  position: sticky;
  top: 0;
  height: 100vh;
  overflow: hidden;
}
.admin-sider >>> .ant-layout-sider-children {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.admin-main-layout {
  min-width: 0;
  height: 100vh;
  overflow: hidden;
}
.admin-header {
  flex: 0 0 64px;
}
.admin-menu-scroll {
  flex: 1;
  min-height: 0;
  padding-bottom: 48px;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
}
.admin-menu-scroll::-webkit-scrollbar {
  width: 6px;
}
.admin-menu-scroll::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(255, 255, 255, .28);
}
.logo img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}
.logo strong {
  color: #fff;
  font-size: 22px;
  white-space: nowrap;
}
.admin-header-right {
  display: flex;
  align-items: center;
}
.admin-header-right {
  gap: 20px;
}
.layout-content {
  flex: 1;
  min-width: 0;
  min-height: 0;
  margin: 16px;
  background: #fff;
  overflow: auto;
}
</style>
